var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonBlock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C11.9778 0 13.9112 0.58649 15.5557 1.6853C17.2002 2.78412 18.4819 4.3459 19.2388 6.17316C19.9957 8.00043 20.1937 10.0111 19.8078 11.9509C19.422 13.8907 18.4696 15.6725 17.0711 17.0711C15.6725 18.4696 13.8907 19.422 11.9509 19.8078C10.0111 20.1937 8.00042 19.9957 6.17316 19.2388C4.3459 18.4819 2.78412 17.2002 1.6853 15.5557C0.586489 13.9112 0 11.9778 0 10C0.00312805 7.34879 1.0577 4.80707 2.93239 2.93239C4.80707 1.0577 7.34879 0.0031277 10 0ZM18.1818 10C18.1825 8.1447 17.549 6.34489 16.3864 4.89909L4.89909 16.3864C6.10135 17.35 7.55156 17.9542 9.08241 18.1291C10.6133 18.304 12.1624 18.0425 13.551 17.3748C14.9396 16.7072 16.1112 15.6605 16.9306 14.3556C17.75 13.0508 18.1837 11.5408 18.1818 10ZM3.61364 15.1009L15.1009 3.61364C13.5307 2.35491 11.5512 1.71986 9.54183 1.83015C7.53241 1.94044 5.63435 2.78833 4.21134 4.21134C2.78833 5.63435 1.94044 7.53241 1.83015 9.54183C1.71986 11.5512 2.35491 13.5307 3.61364 15.1009Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonBlock);
export default __webpack_public_path__ + "static/media/button_block.076bc85067eee24491a7df478abd1637.svg";
export { ForwardRef as ReactComponent };